/* eslint-disable */ 
import {
  RACModal,
  Typography,
  RACButton,
  makeStyles,
  RACSelect,
  TextField,
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStateContext } from '../../../context/user/user-contexts';
import { logActivity } from '../../../api/Customer';
import { ReferenceKeys } from '../../../types/types';
import { mapReferenceResponse, pipe } from '../../../utils/utils';
import { ActivityPayload, CustomerLocationState } from '../../../types/types';
import {
  WORKED_HISTORY_ACTIVITY_TYPE_CODES,
  API_ERROR_MESSAGE,
  SELECT_ONE_OPTION,
  CACHED_KEYS,
  WORKED_HISTORY_CALL_RESULT_CODES,
  TEXT_MAX_LENGTH,
  fieldVisitOptionsDefault,
  fieldVisitOptionsMexico,
} from '../../../constants/constants';
import { getSelectedStore } from '../../../utils/utils';
import { getReference } from '../../../api/reference';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { useCustomerPaymentSummary } from '../../../context/CustomerPaymentSummary/CustomerPaymentSummaryProvider';
import { Option } from '../../../types/types';
// import { orderByDescField } from '../../../context/PastDueListSearchCriteria/PastDueListSearchCriteriaProvider';
import i18n from 'i18next'; // Import i18next
import { useStoreDetails } from '../../../context/Store/StoreProvider';
export interface ModalProps {
  onClose: (onclose: boolean) => void;
  onSaveSuccess: () => void;
  onError: () => void;
  subtype?: string;
  addressId?: number;
}

export interface FieldVisitModalContentProps {
  callResultOptions: Option[];
  apiError: boolean;
  callResult: string;
  note: string;
  isLoading: boolean;

  setCallResult: (result: string) => void;
  setNote: (note: string) => void;
}

const addSelectOneOption = (arrayWithOptions: any[]) => {
  if (!arrayWithOptions) {
    return [
      {
        label: i18n.t(SELECT_ONE_OPTION),
        value: '',
      },
    ];
  }

  return [
    {
      label: i18n.t(SELECT_ONE_OPTION),
      value: '',
    },
    ...arrayWithOptions,
  ];
};

export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    marginBottom: '2rem',
  },
  dialogRoot: {
    '& .MuiPaper-rounded': {
      borderRadius: theme.typography.pxToRem(12),
    },
    '& .MuiDialog-paperWidthXs': {
      maxWidth: theme.typography.pxToRem(500),
    },
    '& .MuiTypography-h5': {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      lineHeight: theme.typography.pxToRem(30),
    },
    '& .MuiTypography-h6': {
      fontFamily: 'OpenSans-semiBold',
      lineHeight: theme.typography.pxToRem(20),
    },
  },
  notesLabel: {
    color: '#212529',
    padding: '0px 0px 15px',
  },
  fieldVisitTextContent: {
    borderRadius: '5px',
    width: theme.typography.pxToRem(450),
  },
  callResultWrapper: {
    width: '75%',
  },
  callResultOptionsPaper: {
    maxHeight: theme.typography.pxToRem(150),
  },
  notesCharacterCount: {
    marginTop: theme.typography.pxToRem(5),
  },
}));

const FieldVisitModalContent = ({
  callResultOptions,
  apiError,
  callResult,
  note,
  isLoading,

  setCallResult,
  setNote,
}: FieldVisitModalContentProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMXAccountManagement } = useStoreDetails();
  const [translatedcallResultOptions, setTranslatedCallResultOptions] =
    useState([]);
 
  const getTranslatedOptions = (options, valuesToInclude) => {
  return [
    { value: '', label: t('Select') },
    ...options
      .filter((option) => valuesToInclude.includes(option.value))
      .map((option) => ({
        ...option,
        label: t(option.label),
      })),
  ];
};

  useEffect(() => {
    const allowedValues = isMXAccountManagement
      ? fieldVisitOptionsMexico
      : fieldVisitOptionsDefault;
    const translated = getTranslatedOptions(callResultOptions, allowedValues);
    setTranslatedCallResultOptions(translated);
  }, [isMXAccountManagement, callResultOptions, t]);
  return (
    <>
      <div className={classes.callResultWrapper}>
        <RACSelect
          classes={{ paper: classes.callResultOptionsPaper }}
          inputLabel={t('Field Visit Result')}
          isDisabled={isLoading}
          defaultValue={callResult}
          loading={isLoading && !callResult.length}
          options={translatedcallResultOptions}
          onChange={(e: React.ChangeEvent<{ value: any }>) =>
            setCallResult(e.target.value)
          }
          {...(apiError && {
            errorMessage: t(API_ERROR_MESSAGE),
          })}
        />
      </div>
      <Typography variant="h6" className={classes.notesLabel}>
        {t('Notes')}
      </Typography>
      <TextField
        className={classes.fieldVisitTextContent}
        multiline
        autoFocus
        variant="outlined"
        maxRows={3}
        minRows={3}
        value={note}
        onChange={(e) => {
          if (note.length >= TEXT_MAX_LENGTH) {
            const trimmedNote = e.target.value?.substring(0, TEXT_MAX_LENGTH);
            setNote(trimmedNote);
          } else {
            setNote(e.target.value);
          }
        }}
      />
      <span className={classes.notesCharacterCount}>
        ({TEXT_MAX_LENGTH}/{note.length})
      </span>
    </>
  );
};

function randomize(array: any) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export const FieldVisitModal = ({
  onClose,
  onSaveSuccess,
  onError,
  subtype,
  addressId,
}: ModalProps) => {
  const classes = useStyles();
  const location = useLocation<CustomerLocationState>();
  const [note, setNote] = useState('');
  const { user } = useUserStateContext();
  const [pending, setPending] = useState(false);
  const [fieldVisitResultOptions, setFieldVisitResultOptions] = useState<
    Option[]
  >([]);
  const [apiError, setApiError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [fieldVisitResult, setFieldVisitResult] = useState('');

  const { customerDetails } = useCustomerDetails();
  const { customerPaymentSummary } = useCustomerPaymentSummary();

  const handleSave = () => {
    const now = new Date().toISOString();
    const customerId =
      customerDetails?.customerId ||
      location?.state?.customer?.customerId ||
      location?.pathname?.split('/')[3];

    const { daysPastDue } = location?.state?.customer || {};

    const payload: ActivityPayload = {
      storeNumber: getSelectedStore(),
      notes: note,
      daysPastDue:
        customerPaymentSummary?.pastDueSummary?.daysPastDue?.toString() ||
        daysPastDue?.toString(),
      activityDate: now,
      callResultRefCode: WORKED_HISTORY_CALL_RESULT_CODES.FIELD_VISIT,
      acctActivityRefCode: WORKED_HISTORY_ACTIVITY_TYPE_CODES.CALL_CUSTOMER,
      //zzz, add fieldvisit result
      fieldVisitResultRefCode: fieldVisitResult,
      customerId: Number(customerId),
      coWorkerId: user?.employeeId || ' ',
      callTime: now,
      ...(subtype && { acctSubActivityRefCode: subtype }),
      ...(addressId && { addressId }),
    };
    setPending(true);
    logActivity(payload)
      .then(() => onSaveSuccess())
      .catch(() => onError())
      .finally(() => setPending(false));
  };
  useEffect(() => {
    setIsLoading(true);
    getReference(
      [ReferenceKeys.FIELD_VISIT_RESULT],
      CACHED_KEYS.FIELDVISITRESULT_CACHED_KEY
    )
      .then((response: any) =>
        pipe(
          randomize,
          mapReferenceResponse,
          addSelectOneOption,
          setFieldVisitResultOptions
        )(response?.references[0]?.referenceDetails)
      )
      .catch(() => {
        setApiError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  const { t } = useTranslation();

  return (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialog: classes.dialogRoot,
      }}
      maxWidth="xs"
      title={t('Field Visit')}
      content={
        <FieldVisitModalContent
          callResultOptions={fieldVisitResultOptions}
          apiError={apiError}
          isLoading={isLoading}
          callResult={fieldVisitResult}
          note={note}
          setCallResult={setFieldVisitResult}
          setNote={setNote}
        />
      }
      onClose={() => onClose(false)}
      buttons={
        <>
          <RACButton
            variant="outlined"
            color="secondary"
            onClick={() => onClose(false)}
            disabled={pending}
          >
            {t('Cancel')}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={!fieldVisitResult.length || isLoading}
            loading={pending}
          >
            {t('Save')}
          </RACButton>
        </>
      }
    />
  );
};
